import Box from '../../components/fela/Box';
import { FelaCSS } from '../../components/fela/flowtypes';
import { DroppedFile } from '../../components/file-uploader/types';
import IconWarningFilled from '../../components/svg/icon-warning-filled';

type Props = {
  dropped: DroppedFile;
  style: {
    fileUploadErrorWrap: FelaCSS;
    fileUploadError: FelaCSS;
  };
};

const UploadingError = ({ dropped, style }: Props) => (
  <Box style={style.fileUploadErrorWrap}>
    <Box style={style.fileUploadError}>
      <IconWarningFilled width={20} color="blushTangerine120" />
      {dropped.msg}
    </Box>
  </Box>
);

export default UploadingError;
